import { render, staticRenderFns } from "./LoginBJurisdiction.vue?vue&type=template&id=1982ffab&scoped=true&"
import script from "./LoginBJurisdiction.vue?vue&type=script&lang=js&"
export * from "./LoginBJurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./LoginBJurisdiction.vue?vue&type=style&index=0&id=1982ffab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982ffab",
  null
  
)

export default component.exports